<template>
    <div class="animated fadeIn">     
    <b-row class="justify-content-center">
      <b-col md="7" lg="6">
        <b-card>
            <div slot="header">Form - Create Annual Budget  
                <div class="card-header-actions">
                    <button class="btn btn-primary mr-1" @click="createBudget()">
                        <i class="fa fa-play"></i>
                        Process
                    </button>
                    <button class="btn btn-danger mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
                </div>
            </div>
            <!-- <b-card no-body> -->
                <b-row>
                    <b-col md="6">
                        <b-input-group >
                            <b-input-group-prepend><label>Annual Budget Of</label></b-input-group-prepend>
                            <b-form-input v-model="model.tahun" type="number"  :state="!$v.model.tahun.$error"></b-form-input>
                        </b-input-group>
                    </b-col>    
                </b-row>    
                <b-input-group>
                    <b-input-group-prepend ><label>Copy From</label></b-input-group-prepend>
                    <b-form-radio-group  class="mt-2" v-model="model.budgetsrc" name="radioIndividu" :state="!$v.model.budgetsrc.$error">
                        <b-form-radio value="0">Previous Budget</b-form-radio>
                        <b-form-radio value="1">Previous Actual</b-form-radio>
                    </b-form-radio-group>
                </b-input-group>
                <b-row class="mb-2">
                    <b-col md="6">
                        <b-input-group >
                            <b-input-group-prepend><label>Year Of Previous</label></b-input-group-prepend>
                            <b-form-input v-model="model.tahunsrc" type="number"  :state="!$v.model.tahunsrc.$error"></b-form-input>
                        </b-input-group>
                    </b-col>    
                    <b-col md="6">
                        <b-input-group >
                            <b-input-group-prepend><label>Global Markup</label></b-input-group-prepend>
                            <b-form-input v-model="model.markup" type="number"  :state="!$v.model.markup.$error"></b-form-input>
                            <b-input-group-append><span class="input-group-text" style="width:100px !important;">% </span></b-input-group-append>
                        </b-input-group>
                    </b-col>    
                </b-row>    
                <h5>Specific Markup by Account </h5>
                <b-table
                    class="mb-0"
                    ref="tblMarkupLines"
                    outlined striped hover small
                    style="font-size:smaller;" 
                    :items="markupLines.items"
                    :fields="markupLines.fields"
                    :current-page="markupLines.page"
                    :per-page="markupLines.limit"
                    >
                        <template v-slot:cell(index)="data">
                        {{data.index + 1}}
                        </template>
                        <template v-slot:cell(action)="data">
                            <div class="text-center">
                            <a href="javascript:void(0)" class="text-danger" @click="delMarkupLines(data.index)">
                                <i class="fa fa-trash"></i>
                            </a>
                            </div>
                        </template>
                        <template v-slot:row-details="row">
                          <b-card class="row-details-form">
                            <b-row>
                            <b-col lg="7">
                                <b-input-group>
                                    <b-input-group-prepend><span class="pt-2 mr-1">GL Account#</span></b-input-group-prepend>
                                    <b-form-input readonly v-model="markupLinesObj.glAccount" @keyup.13.native="lkuCoaShow=true" :state="!$v.markupLinesObj.kodeacc.$error"></b-form-input>
                                    <b-input-group-append>
                                    <b-btn text="Button" @click="lkuCoaShow=true" id="glAccount">
                                        <i class="fa fa-search"></i>
                                    </b-btn>
                                    </b-input-group-append>
                                </b-input-group>
                            </b-col>
                            <b-col lg="5">
                                    <b-input-group >
                                        <b-input-group-prepend><label style="width:60px !important;">Markup</label></b-input-group-prepend>
                                        <b-form-input v-model="markupLinesObj.markupacc"  type="number" ></b-form-input>
                                        <b-input-group-append><span class="input-group-text">% </span></b-input-group-append>
                                        <b-input-group-append>
                                            <b-button v-if="saveEnabled" class="btn btn-info ml-2" @click="saveMarkupLines()">Update</b-button>
                                        </b-input-group-append>
                                        <b-input-group-append>
                                            <b-button class="btn btn-warning ml-1" @click="row.toggleDetails">Cancel</b-button>
                                        </b-input-group-append>
                                    </b-input-group>
                            </b-col>
                            </b-row>
                          </b-card>
                        </template>                        
                </b-table>
                <b-row class="mt-1">
                    <b-col cols="5">
                            <b-button size="sm" class="ml-3" @click="addMarkupLines" >Add Account</b-button>       
                    </b-col>                   
                </b-row>

            <!-- </b-card> -->
        </b-card>
      </b-col>
    </b-row>
        <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       
        <b-modal v-model="showReport" size="xl" scrollable title="Preview as PDF" ok-only>
            <iframe :src="reportUrl" frameborder="0"></iframe>
        </b-modal>
        <b-modal v-model="lkuCoaShow" size="lg" :hide-footer="true" title="Chart Of Account" :centered="true">
            <lku-coa @click="onSelectLkuCoa" :tahun="model.tahunsrc" :key="model.tahunsrc"></lku-coa>
        </b-modal>        
    </div>
</template>

<style lang="scss" scoped>
 
</style>


<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import lkuCoa from "../lookup/lkuCoa";
import budget_dept from "../../apis/budget_dept";
import toastr from "mini-toastr";
import moment from 'moment';
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
toastr.init();

export default {
  mixins: [validationMixin],
  validations: {
    markupLinesObj: {
        kodeacc: { required },
        markupacc: { required }
    },
    model: {
        tahun: { required },
        budgetsrc: { required },
        tahunsrc: { required },
        markup: { required },
    },
  }, 
  data() {
    return {
      filter: {tabIndex:1,layout:'', departkd:'',tahun:moment(this.$store.state.user.tglaktif).format('YYYY')},
      model: {tahun:'', budgetsrc:0,markup:0,tahunsrc:parseInt(this.$store.state.user.tglaktif.substring(0,4))},
      nextYear: parseInt(this.$store.state.user.tglaktif.substring(0,4))+1,
      saveEnabled: true,
      lkuCoaShow:false,
      isLoading: false,
        markupLines: {
            items: [],
            selected:{},
            fields: [
                {key: 'index', label: 'No.' ,thStyle: "width:40px"},
                {
                    key: "kodeacc",
                    label: "Kode Account",
                },
                {
                    key: "namaacc",
                    label: "Nama Account"
                },
                {
                    key: "markupacc",
                    label: "MarkUp (%)",
                    thStyle: "width:80px",
                    thClass: "text-center",
                },
                {
                    key: "action",
                    label: "Action",
                    thStyle: "width:60px",
                    thClass: "text-center",
                },
            ],
            page: 1,
            limit: 100,
            total: 0,
        },
        markupLinesObj:{kodeacc:'', glAccount:'', markupacc:''},
      showAddConfirm:false,
      layouts:[],
      horizontal: true,
      reportUrl: null,
      showReport:false,
      rptLines:[]
    };
  },
components: { lkuCoa,Loading },  
computed:{
    invalidMarkupLines() {
      this.$v.markupLinesObj.$touch();
      return this.$v.markupLinesObj.$invalid;
    },
    invalidModel() {
      this.$v.model.$touch();
      return this.$v.model.$invalid;
    },
  },
created: async function (){
    this.model.tahun=parseInt(this.$store.state.user.tglaktif.substring(0,4))+1;
     const data = await budget_dept.copywithmarkup(this.model);
     const row=data[0];
     if (row) {
         this.model.tahun=row.tahun;
         this.model.budgetsrc=row.budgetsrc;
         this.model.tahunsrc=row.tahunsrc;
         this.model.markup=row.markup;
         this.markupLines.items=data[1];
         this.markupLines.total = data[1].length;
     }
  },
methods:{
    onSelectLkuCoa: async function (_selected) {
        this.markupLinesObj.glAccount = _selected.kodeacc.trim() + ' | ' + _selected.namaacc.trim();
        this.markupLinesObj.kodeacc = _selected.kodeacc;
        this.markupLinesObj.namaacc = _selected.namaacc;
        this.lkuCoaShow=false;
    },
    createBudget: async function() {
        if (this.invalidModel) {
            toastr.error('Please fill the form correctly.');
       } else {
           try {                
            this.isLoading=true;
            // this.model.nextYear=this.nextYear;
            await budget_dept.createBudget(this.model);
            this.showAddConfirm = false;
            toastr.success('CREATE BUDGET completed successfully');
            // this.refresh();               
           } catch (error) {
                if (error.message) {
                    toastr.error(error.message);
                } else {
                    toastr.error(JSON.stringify(error));
                }               
           }
            this.isLoading=false;
       }
    },
    closeMarkupLines: function(){
        const opened= this.markupLines.items.find( r=> r._showDetails==true);
        if (opened) opened._showDetails=false;
    },
    addMarkupLines : function () {
        this.closeMarkupLines();
        const obj={_showDetails:true};
        this.markupLines.selected = obj;
        for (var key in this.markupLinesObj) {
            this.markupLinesObj[key] = '';
        }
        this.markupLinesObj.markup = 0;
        this.markupLines.items.push(obj);
        this.markupLines.total=this.markupLines.items.length;
        setTimeout(() => {
            const bfore = this.markupLines.page;
            const after =Math.ceil((this.markupLines.total)/this.markupLines.limit);
            if (bfore != after){
                this.markupLines.page =  after;                 
                toastr.info(`Move to page ${after} of total  ${this.markupLines.total} items`,'Line/Detail',10000);
            }

        }, 100);    
    },
    editMarkupLines : function (obj,callback) {
        this.closeMarkupLines();
        this.markupLines.selected = obj;
        for (var key in this.markupLinesObj) {
            this.markupLinesObj[key] = '';
        }
        for (var key in obj) {
            this.markupLinesObj[key] = obj[key];
        }
        this.markupLinesObj.glAccount = obj.kodeacc.trim() + ' | ' + obj.namaacc.trim();
        callback();
    },
    delMarkupLines: function (index) {
        if (index > -1) {
            // this.markupLines.items.splice(index, 1);
            const posisi = (this.markupLines.page-1)*this.markupLines.limit;
            this.markupLines.items.splice(posisi+index, 1);
        }
        this.markupLines.total=this.markupLines.items.length;
    },
    saveMarkupLines: async function (callback) {
        if (this.invalidMarkupLines) {
            toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
       } else {
            try {
                const row= {
                    tablekey : this.model.tablekey ||'',
                    tahun: this.model.tahun,
                    budgetsrc: this.model.budgetsrc,
                    tahunsrc: this.model.tahunsrc,
                    markup: this.model.markup
                };
                for (var key in this.markupLinesObj) {
                    this.markupLines.selected[key] = this.markupLinesObj[key];
                    row[key] = this.markupLinesObj[key];
                }
                this.markupLines.selected._showDetails=false;
                if (callback) callback();
                const hasil = await budget_dept.savecopywithmarkup(row);
                this.model.tablekey = hasil.tablekey;
                this.markupLines.selected.tabledtkey= hasil.tabledtkey;
                this.markupLines.total=this.markupLines.items.length;

            } catch (error) {
                console.log('save : ', error)
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
                } else {
                    toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                }               
          }
        }
    },

    close(){
      if ((this.$store.state.prevRoute.name) && (this.$store.state.prevRoute.name !== 'budget.annualbudgetcopy')) {
        router.push({name:this.$store.state.prevRoute.name});
      } else {
          router.push({name:"budget.annualbudget"});
        //   router.push("home");
      }
    }
  }
};
</script>
